import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import TopNavbar from "./TopNavbar";
import SideDrawer from "./SideDrawer";

import "../../styles/Layout.css";

export default function Layout() {

    //-----------------------------------------
    // Détection de la taille de l'écran
    //-----------------------------------------

    const isMobile = window.innerWidth <= 992;

    //-----------------------------------------
    // Etat du menu
    //-----------------------------------------

    const [drawerOpen, setDrawerOpen] = useState(!isMobile);

    //-----------------------------------------
    // Afficher / masquer le menu
    //-----------------------------------------

    const handleToggleDrawer = () => {

        setDrawerOpen(prev => !prev);

    };

    //-----------------------------------------

    const handleCloseDrawer = () => {

        setDrawerOpen(false);

    };

    //-----------------------------------------
    // Si on redimensionne l'écran
    //-----------------------------------------

    useEffect(() => {

        const handleResize = () => {

            if (window.innerWidth <= 992) {

                setDrawerOpen(false);

            } else {

                setDrawerOpen(true);

            }

        };

        window.addEventListener("resize", handleResize);

        return () => {

            window.removeEventListener("resize", handleResize);

        };

    }, []);

    //-----------------------------------------

    return (

        <div className="layout">

            {/* Navbar */}

            <TopNavbar
                onToggleDrawer={handleToggleDrawer}
            />

            {/* Drawer */}

            <SideDrawer
                open={drawerOpen}
                onClose={handleCloseDrawer}
            />

            {/* Overlay */}

            {

                drawerOpen &&
                window.innerWidth <= 992 &&

                <div
                    className="layout-overlay"
                    onClick={handleCloseDrawer}
                />

            }

            {/* Contenu */}

            <main
                className={

                    drawerOpen

                        ? "layout-content drawer-visible"

                        : "layout-content drawer-hidden"

                }
            >

                <Outlet />

            </main>

        </div>

    );

}